import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import {
  CardContent,
  Dialog,
  Typography,
  Zoom,
} from "@mui/material";
import { useEffect, useState } from "react";
import ContactDisplay from "./Components/ContactDisplay";
import GroupDisplay from "./Components/GroupDisplay";
import CreateContact from "./Components/CreateContact";
import CreateGroup from "./Components/CreateGroup";
import { Group, Person } from "@mui/icons-material";

function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [groups, setGroup] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);

  //load contacts

  const myContacts = async () => {
    const response = await fetch("http://127.0.0.1:8000/messenger/contacts/", {
      mode: "cors",
      method: "GET",
    });
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }

      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);

    let finalData = JSON.parse(result);
    setContacts(finalData);
    console.log(finalData);
  };

  useEffect(function myFunc() {
    myContacts();
  }, []);

  const handleEdit = (individual) => {
    const AlteredConts = contacts.map((person) => {
      if (person === individual) {
        person.edit = person.edit === true ? false : true;
      }
      return person;
    });
    setContacts(AlteredConts);
  };
  const handleGroupSave = () => {};

  const handleSave = async (individual) => {
    const response = await fetch("http://127.0.0.1:8000/messenger/contacts/", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(individual),
    });
    const fetcher = response.body
      .pipeThrough(new TextDecoderStream("utf-8"))
      .getReader();
    let data = "";
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }
      data += value;
    }

    const newContacts = [...contacts, individual];
    setOpenDialog(false);

    setContacts(newContacts);
  };

  const handleDelete = (individual) => {
    const AlteredConts = contacts.filter((person) => {
      if (person === individual) {
        return false;
      }
      return true;
    });
    setContacts(AlteredConts);
  };

  //dialog handling

  const [dialogContent, setDialogContent] = useState(null);
  const [showContact, setShowContact] = useState("flex");
  const [showGroups, setShowGroups] = useState("none");

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6">Contacts</Typography>
        <Divider />
        <Stack mt={2}>
          <Box
            display={{ xs: "none", sm: "flex" }}
            justifyContent={"space-evenly"}
            mb={2}
          >
            <TextField size="small" label="Search" />
            <Button
              variant="outlined"
              onClick={() => {
                setShowContact("flex");
                setShowGroups("none");
              }}
            >
              Contacts
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setShowGroups("flex");
                setShowContact("none");
              }}
            >
              Groups
            </Button>
            <Tooltip title="create contact">
              <IconButton
                onClick={() => {
                  setDialogContent(<CreateContact handleSave={handleSave} />);
                  setOpenDialog(true);
                }}
              >
                <PersonAddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="create group">
              <IconButton
                onClick={() => {
                  setDialogContent(
                    <CreateGroup handleSave={handleGroupSave} />
                  );
                  setOpenDialog(true);
                }}
              >
                <GroupAddIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box
            display={{ xm: "flex", sm: "none" }}
            justifyContent={"space-evenly"}
            mb={2}
          >
            <TextField size="small" label="Search" />
            <IconButton
              variant="outlined"
              onClick={() => {
                setShowContact("flex");
                setShowGroups("none");
              }}
            >
              <Person />
            </IconButton>
            <IconButton
              variant="outlined"
              onClick={() => {
                setShowGroups("flex");
                setShowContact("none");
              }}
            >
              <Group />
            </IconButton>
            <Tooltip title="create contact">
              <IconButton
                onClick={() => {
                  setDialogContent(<CreateContact handleSave={handleSave} />);
                  setOpenDialog(true);
                }}
              >
                <PersonAddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="create group">
              <IconButton
                onClick={() => {
                  setDialogContent(
                    <CreateGroup handleSave={handleGroupSave} />
                  );
                  setOpenDialog(true);
                }}
              >
                <GroupAddIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Divider />
          <Stack display={showContact}>
            {contacts.length > 0 ? (
              contacts.map((person) => {
                return (
                  <Card elevation={3} sx={{ my: 1 }} key={person.id}>
                    <CardContent>
                      <ContactDisplay
                        person={person}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handleSave={handleSave}
                      />
                    </CardContent>
                  </Card>
                );
              })
            ) : (
              <Typography>No Contacts</Typography>
            )}
          </Stack>
          <Stack display={showGroups}>
            {groups.map((group) => {
              return (
                <Card elevation={3} sx={{ my: 1 }}>
                  <CardContent>
                    <GroupDisplay
                      group={group}
                      handleEdit={handleEdit}
                      handleDelete={handleDelete}
                      handleSave={handleSave}
                    />
                  </CardContent>
                </Card>
              );
            })}
          </Stack>
        </Stack>
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth>
          {dialogContent}
        </Dialog>
      </Stack>
    </Zoom>
  );
}

export default Contacts;
